export default __webpack_public_path__ + "static/media/movie-hub.59be2725.gif";